export const paymentMethodMutationKeys = {
  baseMutation: ['payments-payment-method'],
  attachPaymentMethod: ['payments-payment-method', 'attach-payment-method'],
  detachPaymentMethod: ['payments-payment-method', 'detach-payment-method'],
};
